export default {
    getDividaById: (state) => (id) => {
        return state.dividas.data.find(divida => divida.id === id)
    }
}